import { render, staticRenderFns } from "./examine.vue?vue&type=template&id=2b1160ef&scoped=true&"
import script from "./examine.vue?vue&type=script&lang=js&"
export * from "./examine.vue?vue&type=script&lang=js&"
import style0 from "./examine.vue?vue&type=style&index=0&id=2b1160ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1160ef",
  null
  
)

export default component.exports